import FileUploader from 'components/organisms/FileUploader';
import type { FileUploaderProps } from 'components/organisms/FileUploader/FileUploader.types';
import { useExpensesDropzone } from 'hooks/Expenses/filesUploadHooks/useExpensesDropzone';
import { CustomDropzoneConfig } from 'hooks/useCustomDropzoneStore';
import type { FC } from 'react';

const ExpensesFileUploader: FC<
  Omit<
    FileUploaderProps,
    'filesStateApi' | 'processFileUpload' | 'dropzoneAPI'
  > & {
    onUpload: CustomDropzoneConfig['onUpload'];
  }
> = (props) => {
  const { storeAPI, dropzoneAPI, processFileUpload } = useExpensesDropzone({
    onUpload: props.onUpload,
    options: (filesMeta) => ({
      ...props.dropzoneProps?.dropOptions,
      ...props.dropzoneProps.getDropOptions?.(filesMeta),
      onAfterDropAccepted: props.onAfterDropAccepted,
    }),
    defaultSchedulerOptions: {
      keepAlive: props.keepUploadingAfterDestroy,
      onComplete: props.afterPatchUpload,
    },
  });

  return (
    <FileUploader
      {...props}
      filesStateApi={storeAPI}
      dropzoneAPI={dropzoneAPI}
      processFileUpload={processFileUpload}
      renderExtra={props.renderExtra}
      filesListProps={{
        groupFailedFiles: true,
        ...props.filesListProps,
      }}
    />
  );
};

export default ExpensesFileUploader;
